import * as Types from '../types/SubscriptionCancelationFeedback';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    masterState: {},
    isAction: false,
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.SUBSCRIPTION_CANCELATION_FEEDBACK_LIST_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_CANCELATION_FEEDBACK_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.listFeedback};
        case Types.SUBSCRIPTION_CANCELATION_FEEDBACK_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.SUBSCRIPTION_CANCELATION_FEEDBACK_INIT:
            return initialState;
        default:
            return state;
    }
}
